const TZ = 'Asia/Shanghai';

function getParts(d: Date): Record<string, string> {
  const fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false,
  });
  const map: Record<string, string> = {};
  for (const { type, value } of fmt.formatToParts(d)) {
    map[type] = value;
  }
  return map;
}

export function formatDate(value: string | number | Date): string {
  const p = getParts(new Date(value));
  return `${p.year}-${p.month}-${p.day}`;
}

export function formatDateTime(value: string | number | Date): string {
  const p = getParts(new Date(value));
  return `${p.year}-${p.month}-${p.day} ${p.hour}:${p.minute}:${p.second}`;
}

export function formatDateTimeShort(value: string | number | Date): string {
  const p = getParts(new Date(value));
  return `${p.year}-${p.month}-${p.day} ${p.hour}:${p.minute}`;
}

export function formatTime(value: string | number | Date): string {
  const p = getParts(new Date(value));
  return `${p.hour}:${p.minute}:${p.second}`;
}

export function formatTimeAgo(value: string | number | Date, locale: string = 'en'): string {
  const now = Date.now();
  const past = new Date(value).getTime();
  const diffSec = Math.floor((now - past) / 1000);

  if (diffSec < 60) return locale === 'zh' ? '刚刚' : 'just now';

  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return locale === 'zh' ? `${diffMin} 分钟前` : `${diffMin}m ago`;

  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return locale === 'zh' ? `${diffHr} 小时前` : `${diffHr}h ago`;

  const diffDay = Math.floor(diffHr / 24);
  if (diffDay < 30) return locale === 'zh' ? `${diffDay} 天前` : `${diffDay}d ago`;

  const diffMonth = Math.floor(diffDay / 30);
  if (diffMonth < 12) return locale === 'zh' ? `${diffMonth} 个月前` : `${diffMonth}mo ago`;

  const diffYear = Math.floor(diffMonth / 12);
  return locale === 'zh' ? `${diffYear} 年前` : `${diffYear}y ago`;
}
